module.exports = __webpack_public_path__ + "static/el-obrero-internacional-3-b32d62b89ce3b70119efd9fce80baa84.png";